import {
  Injectable,
} from '@angular/core';
import {
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';

import { InformationPageComponent } from './information-page.component';
import { InformationPageService } from './information-page.service';


@Injectable()
export class CanDeactivateInformationPage implements CanDeactivate<InformationPageComponent> {
  constructor(
    private informationPageService: InformationPageService
  ) {}

  canDeactivate(
    component: InformationPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean>|Promise<boolean>|boolean {
    if (component.isDirty) {
      this.informationPageService.emitShowBeforeLeavingModal();
      return this.informationPageService.canDeactivateSubj.asObservable();
    } else {
      return true;
    }
  }
}
